import React from 'react';
import {usePermissions} from '../hooks/usePermissions';

const PermissionGuard = ({
    children,
    permission,
    permissions,
    requireAll = false,
    fallback = null,
    role,
    showFallback = true
}) => {
    const {hasPermission, hasAnyPermission, hasAllPermissions, userRole} = usePermissions();

    let hasAccess = false;

    if (role) { // Check for specific role
        hasAccess = userRole === role;
    } else if (permission) { // Check for single permission
        hasAccess = hasPermission(permission);
    } else if (permissions) { // Check for multiple permissions
        hasAccess = requireAll ? hasAllPermissions(permissions) : hasAnyPermission(permissions);
    }

    if (! hasAccess) {
        if (!showFallback) 
            return null;
        


        return(fallback || (
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-center">
                <p className="text-yellow-700 font-medium">Access Restricted</p>
                <p className="text-yellow-600 text-sm mt-1">
                    You don't have permission to view this content.
                </p>
            </div>
        ));
    }

    return children;
};

export default PermissionGuard;
